import { Box, Typography, Button, type SvgIconProps } from '@mui/material';
import type { ReactElement } from 'react';

interface EmptyStateProps {
  icon?: ReactElement<SvgIconProps>;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
    variant?: 'contained' | 'outlined' | 'text';
  };
  minHeight?: number | string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  minHeight = 300,
}: EmptyStateProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight,
        py: 6,
        px: 3,
        textAlign: 'center',
      }}
      role="status"
      aria-label={title}
    >
      {icon && (
        <Box
          sx={{
            mb: 2,
            color: 'text.secondary',
            opacity: 0.5,
            '& > svg': {
              fontSize: 64,
            },
          }}
          aria-hidden="true"
        >
          {icon}
        </Box>
      )}

      <Typography
        variant="h6"
        color="text.secondary"
        gutterBottom
        sx={{ fontWeight: 500 }}
      >
        {title}
      </Typography>

      {description && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ maxWidth: 400, mb: action ? 3 : 0 }}
        >
          {description}
        </Typography>
      )}

      {action && (
        <Button
          variant={action.variant || 'contained'}
          onClick={action.onClick}
          sx={{ mt: 2 }}
        >
          {action.label}
        </Button>
      )}
    </Box>
  );
}
